import React, { useState, useCallback, useMemo } from "react";
import { createAvtarName } from "../../../../utils";
import Avatar from "../../../../components/Avatar";
import UserProfile from "./UserProfile";

function UserName({ params }) {
  const [userProfile, setUserProfile] = useState(false);
  const [user, setUser] = useState({});

  const handleUserClick = useCallback((user) => {
    setUserProfile(true);
    setUser(user);
  }, []);
  const handleCloseDialog = useCallback(() => {
    setUserProfile(false);
    setUser({});
  }, []);



  const fullName = useMemo(() => {
    return `${params.row.first_name} ${params.row.last_name}`;
  }, [params.row.first_name, params.row.last_name]);

  return (
    <>
      {(userProfile && user.user_id) && (
        <UserProfile
          open={userProfile}
          userId={user?.user_id}
          handleClose={()=>handleCloseDialog()}
        />
      )}
      <div
        className="d-flex align-items-center cursor-pointer"
        onClick={() => handleUserClick(params?.row)}>
        <Avatar
          // key={`user-avtar-${el.user_id}`}
          username={fullName}
          user_image={params.row.user_image}
          title={fullName}
          className="user-avtar-dropdown user-avatar  mr-2"
          style={
            !params.row.user_image && {
              bgcolor: params.row?.profile_color?.background,
              color: params.row?.profile_color?.text,
            }
          }>
          {createAvtarName(fullName)}
        </Avatar>
        <p
          style={{
            textDecoration: "underline",
          }}>{`${params.row.first_name} ${params.row.last_name}`}</p>
      </div>
    </>
  );
}

const isChangeUserName = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.user_id === nextProps?.params?.row?.user_id
    && prevProps?.params?.row?.first_name === nextProps?.params?.row?.first_name
    && prevProps?.params?.row?.last_name === nextProps?.params?.row?.last_name
    && prevProps?.params?.row?.user_image === nextProps?.params?.row?.user_image
    && prevProps?.params?.row?.profile_color?.text === nextProps?.params?.row?.profile_color?.text
    && prevProps?.params?.row?.profile_color?.background === nextProps?.params?.row?.profile_color?.background
  );
};

export default React.memo(UserName, isChangeUserName);
